import React from "react";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import "../../../../css/Common/Components/DesignSystem/Arrow.css";

// ArrowRight is a React component that renders a right-pointing arrow button.
// It uses MUI's IconButton and ChevronRightIcon for the UI.
// The component manages its own clicked state for styling purposes.

class ArrowRight extends React.Component {
  constructor() {
    super();

    // Initialize state: 'clicked' toggles on click, 'greenClicked' is unused.
    this.state = {
      clicked: false,
      greenClicked: false,
    };
  }

  render() {
    const { onClick, disabled } = this.props;
    return (
      <div
        // Apply CSS classes based on 'clicked' and 'disabled' state/prop.
        className={`Arrow-Container ${this.state.clicked ? "clicked" : ""}  ${
          disabled ? "disabled" : ""
        }`}
        // Toggle 'clicked' state and call the onClick prop when clicked.
        onClick={() => {
          this.setState({ clicked: !this.state.clicked });
          onClick();
        }}
      >
        {/* Render the right arrow icon inside an IconButton */}
        <IconButton className="Arrow-Icon" disableRipple>
          <ChevronRightIcon className="Arrow-Icon" />
        </IconButton>
      </div>
    );
  }
}

export default ArrowRight;
